import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import dayjs from 'dayjs';

import { useFormik } from 'formik';
import { PartnerListBox } from '../../components/partnermng/PartnerListBox';

const PartnerSearchContainer = ({
  searchList,
  searchPartnerTyp,
  searchKeyword,
  searchWords,
  downloadExl,
  uploadExl,
}) => {
  const navigate = useNavigate();
  const handleAdd = () => {
    navigate('/partnermng/add');
  };

  const initialValues = {
    searchPartnerTyp: searchPartnerTyp,
    searchKeyword: searchKeyword,
    searchWords: searchWords,
  };

  const validationSchema = yup.object({
    searchPartnerTyp: yup.string().nullable(),
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      searchList(values);
      setSubmitting(false);
    },
  });
  return (
    <PartnerListBox
      formik={formik}
      handleAdd={handleAdd}
      downloadExl={downloadExl}
      uploadExl={uploadExl}
    />
  );
};

export default PartnerSearchContainer;
